<template>
  <div class="row px-4">
    <div class="form-group col-md-6 offset-md-3 col-sm-12" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <question
        v-model="applicationData.quiz_easy_off_effect"
        :label="$t('questions.quiz_easy_off')"
        :readonly="readonly"
        :error="errors.QUIZ_ERROR"
        :options="localizedQuizEasyOffOptions"
        :stacked="true"
        :rules="{ required: true, is: $t('options.quiz_easy_off.damage') }"
      />
    </div>
    <div class="form-group col-md-6 offset-md-3 col-sm-12" data-aos="fade-left" data-aos-duration="1500" data-aos-delay="200">
      <question
        v-model="applicationData.quiz_hardwood"
        :label="$t('questions.quiz_hardwood')"
        :readonly="readonly"
        :error="errors.QUIZ_ERROR"
        :options="localizedQuizHardwoodOptions"
        :stacked="true"
        :rules="{ required: true, is: $t('options.quiz_hardwood.all_purpose') }"
        />
    </div>
    <div class="form-group col-md-6 offset-md-3 col-sm-12" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <question
        v-model="applicationData.quiz_late"
        :label="$t('questions.quiz_late')"
        :readonly="readonly"
        :error="errors.QUIZ_ERROR"
        :options="localizedQuizLateOptions"
        :stacked="true"
        :rules="{ required: true, is: $t('options.quiz_late.notify_asap') }"
      />
    </div>
    <more-info />
  </div>
</template>
<script>
import '@/shared/validations.js'
import Vue from 'vue'
import Question from '@/shared/fields/cleaner_app_form_question.vue'
import MoreInfo from './more_info.vue'

export default {
  components: {
    Question, MoreInfo
  },
  props: {
    readonly: {
      type: Boolean,
      required: true
    },
    applicationData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      errors: $errors,
      options: $options
    }
  },
  computed: {
    localizedQuizEasyOffOptions() {
      let options = []
      this.options.QUIZ_EASY_OFF.forEach((key) => {
        options.push(this.$t('options.quiz_easy_off.' + key))
      })
      return options
    },
    localizedQuizHardwoodOptions() {
      let options = []
      this.options.QUIZ_HARDWOOD.forEach((key) => {
        options.push(this.$t('options.quiz_hardwood.' + key))
      })
      return options
    },
    localizedQuizLateOptions() {
      let options = []
      this.options.QUIZ_LATE.forEach((key) => {
        options.push(this.$t('options.quiz_late.' + key))
      })
      return options
    },
  },
  methods: {

  }
}
</script>
